import clsx from 'clsx';
import { InlineArrowRightIcon } from '../../../../../shared/ui/icons';
import styles from '../TemplatesList.module.css';

export function SortCaption({ option }) {
  if (option.label != null) {
    return option.label;
  }
  return (
    <span className={clsx(styles.sortCaptionRange)}>
      {option.from}
      <InlineArrowRightIcon className={clsx(styles.sortCaptionArrow)} />
      {option.to}
    </span>
  );
}
